import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-check-tick]',
  templateUrl: './check-tick.component.html',
  styleUrls: ['./check-tick.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckTickComponent implements OnInit {

  @Input() checked: boolean = false

  constructor() { }

  ngOnInit(): void {
  }

}
